<template>
  <slide-up-down :active="shouldShow" :duration="500">
    <div class="loader">
      <img
        src="@/assets/img/union-loader.gif"
        class="image"
        alt="adatok letöltése folyamatban..."
      />
    </div>
  </slide-up-down>
</template>

<script>
import { EventBus } from "@/main.js";

export default {
  name: "Loader",
  created: function() {
    var self = this;
    //this.$log.debug(this);
    //requesting loader show

    //
    EventBus.$on("loader:show", function(loaderId) {
      //self.$log.debug("event loader:show detected");
      if (Object.prototype.hasOwnProperty.call(self.loading, loaderId)) {
        //if (self.loading.hasOwnProperty(loaderId)) {
        self.loading[loaderId] = true;
      } else {
        self.$set(self.loading, loaderId, true);
      }
    });

    //requesting loader hide
    EventBus.$on("loader:hide", function(loaderId) {
      //self.$log.debug("event loader:hide detected");
      if (Object.prototype.hasOwnProperty.call(self.loading, loaderId)) {
        //if (self.loading.hasOwnProperty(loaderId)) {
        self.$delete(self.loading, loaderId);
      }
    });
  },

  //component data properties
  //returns object with loading property object
  //loading prop object is containing process name keys with boolean values indicating if there is related loading in progress
  data: function() {
    return {
      loading: {
        //'processName': true
      }
    };
  },

  //component computed values
  computed: {
    shouldShow: function() {
      var result = false;
      for (var key in this.loading) {
        if (Object.prototype.hasOwnProperty.call(this.loading, key)) {
          //if (this.loading.hasOwnProperty(key)) {
          result = this.loading[key];
          if (result) {
            break;
          }
        }
      }
      return result;
    }
  },

  filters: {},

  methods: {},

  watch: {}
};
</script>

<style lang="scss" scoped>
//Add "scoped" attribute to limit CSS to this component only
//@import "@/scss/_variables.scss";   //imported globally

.loader {
  position: relative;
  display: block;
  box-sizing: border-box;
  font-size: 1em;
  margin: 0px;
  padding: 0.5em 0px 1em 0px;
  width: 100%;

  .image {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 1em;
    width: 12.5em;
    height: auto;
    margin: 0px auto 0px auto;
    padding: 0px;
  }
}
</style>
